import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Residential from './Residential';
import Commercial from './Commercial';
import services1 from '../../images/services1.jpeg';
import services2 from '../../images/services2.jpeg';
import services3 from '../../images/services3.jpeg';
import services4 from '../../images/services4.jpeg';

const ServiceSectionS2 = (props) => {

      return (
        <>
      {/* SCROLL TARGET FOR BACK-TO-TOP */}
      <div id="scrool"></div>
       <div className="services-wrapper">
    
          {/* --------------------------------------------- */}
          {/* FULL SERVICE MANAGEMENT */}
          {/* --------------------------------------------- */}
          <div className="service-block">
            <div className="text-area">

              <h2>Full Service Management</h2>
    
              <p>
                Our focus is on delivering exceptional service and working closely with
                each client. Our experienced community managers collaborate with the
                board to share best practices across all areas of community management,
                including:
              </p>
    
              <ul className="service-list">
                <li>Board education and governance</li>
                <li>Vendor selection and cost-reduction strategies</li>
                <li>Financial accounting, delinquency, and collection services</li>
                <li>Site reviews, compliance, violations, and maintenance</li>
                <li>Homeowner engagement, including sub-committees</li>
                <li>Strategic planning and project management oversight</li>
              </ul>
    
              <p>
                Our commitment to client service is unmatched in the industry, and our
                advanced technology surpasses that of any other management firm.
                Thanks to our strong partnerships, we offer a wide array of services to
                our clients and their homeowners. Legacy Community Services has
                invested heavily in cutting-edge management software, providing a
                significant advantage. Through our increasing use of modern technology,
                we deliver top-tier services to our clients while maintaining competitive
                pricing.
              </p>
            </div>
    
            <img src={services1} alt="services1" />
          </div>
    
    
          {/* --------------------------------------------- */}
          {/* FINANCIAL MANAGEMENT SERVICES */}
          {/* --------------------------------------------- */}
          <div className="service-block">
            <div className="text-area">
    
              <Link className="service-btn" to="/proposal">PROPOSAL REQUEST</Link>
    
              <h2>Financial Management Services</h2>
    
              <p>
                At Legacy Community Services, we ensure accurate and timely
                reporting across all areas of financial management, including accounts
                payable, accounts receivable, bank reconciliations, general ledger
                maintenance, financial statement preparation, budget planning, Resale
                Disclosure preparation, and participation in annual or budget meetings.
              </p>
    
              <p>
                <strong>Financial Only Plus –</strong> This customizable package can be
                tailored to meet your community’s specific needs by offering a mix of
                full-service and financial-only solutions. Additional services, such as
                management consulting, covenant enforcement support, and contract
                administration, can be added to the core financial-only package based on
                your requirements.
              </p>
            </div>
    
            <img src={services2} alt="services2" />
          </div>
    
    
          {/* --------------------------------------------- */}
          {/* ON-SITE MANAGEMENT SERVICES */}
          {/* --------------------------------------------- */}
          <div className="service-block">
            <div className="text-area">
    
              <h2>On-Site Management Services</h2>
    
              <p>
              Legacy Community Services offers exclusive access to a wide range of
                services designed to support the communities we manage. Whether you’re
                transitioning from another management provider or looking to enhance your
                budgeting process, we’re here to make things easier for you. Some of the
                services we provide include:
              </p>
    
              <ul className="service-list">
                <li>Strategic planning</li>
                <li>Financial management</li>
                <li>Physical asset analysis and preventive maintenance programs</li>
                <li>Leadership planning</li>
                <li>Proprietary technology innovations</li>
                <li>Board member training</li>
                <li>Transition programs</li>
                <li>Industry-leading training and professional development</li>
                <li>Workflow management systems and processes</li>
                <li>Value-added services (combined buying power & negotiated pricing)</li>
                <li>24/7 Customer Care Center</li>
                <li>Developer services</li>
                <li>Staff recruitment, training, and payroll services</li>
              </ul>
    
              <p>
                No matter where your community is located, our mission is to make your
                residents proud of where they live. We strive to build lasting
                relationships with both your community and its residents by consistently
                delivering on our promises and exceeding expectations.
              </p>
            </div>
    
            <img src={services3} alt="services3" />
          </div>
    
    
          {/* --------------------------------------------- */}
          {/* PROPERTY MANAGEMENT SERVICES */}
          {/* --------------------------------------------- */}
          <div className="service-block">
            <div className="text-area">
    
              <Link className="service-btn" to="/proposal">PROPOSAL REQUEST</Link>
    
              <h2>Property Management Services</h2>
    
              <p>
                At Legacy Community Services, we understand that nothing is more
                important than the condition and beauty of your community. Our managers
                are dedicated to maintaining the quality of your common areas and
                infrastructure. Whether it’s routine grounds maintenance or managing the
                complex systems of high-rise buildings, we oversee the care of every
                aspect of your community.
              </p>
    
              <p>
                We collaborate closely with your reserve specialist to ensure that your
                reserve study covers all property components and that repairs and new
                projects are properly included in each reserve study update.
              </p>
    
              <p>
                Our team carefully budgets for routine maintenance costs, reserve
                contributions, and anticipated reserve expenditures. We also maintain
                detailed inventory, inspection, and maintenance schedules to ensure the
                upkeep of your community is timely and thorough.
              </p>
    
              <p>
                Your association is not limited to “preferred vendors.” We engage in
                competitive and transparent bidding processes for service providers, and
                we work closely with selected vendors to deliver high-quality service to
                your community.
              </p>
    
              <p>
                Additionally, our managers develop emergency preparedness plans and are
                available for emergency response 24/7.
              </p>
            </div>
    
            <img src={services4} alt="services4" />
          </div>
        </div>
        </>
      );
    };
        

export default ServiceSectionS2;